import { EmailRounded, WhatsApp } from "@mui/icons-material";
import { Grid, Link, styled, Tab, Tabs } from "@mui/material";
import formatters from "../../utils/formatters";
import Card from "../Card";

const ImageContainer = styled("div")`
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadiuses.imageHolders};
  background-color: ${({ theme }) => theme.colors.primary._100};
  font-size: 68px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary._700};
`;
const NomeCliente = styled("span")`
  font-size: ${({ theme }) => theme.fonts.size.parceiro.title};
  font-family: ${({ theme }) => theme.fonts.family.default};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.grey._700};
`;
const CpfCnpj = styled("div")`
  font-size: ${({ theme }) => theme.fonts.size.parceiro.subtitle};
  font-family: ${({ theme }) => theme.fonts.family.default};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.grey._200};
`;
const NomeParceiro = styled("div")`
  font-size: ${({ theme }) => theme.fonts.size.parceiro.subtitle};
  font-family: ${({ theme }) => theme.fonts.family.default};
  font-weight: 700;
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.colors.secondary._600};
`;
const TabContainer = styled(Tabs)`
  display: flex;
  margin: 1.5rem 0 -1.5rem;
  border-top: solid 2px ${({ theme }) => theme.colors.grey._50};
  font-size: ${({ theme }) => theme.fonts.size.operacao.subtitle};
  font-family: ${({ theme }) => theme.fonts.family.default};

  & .MuiTab-root {
    letter-spacing: 0;
  }

  & .MuiTabs-indicator {
    height: 3px;
    background-color: ${({ theme }) => theme.colors.primary._400};
  }

  & .MuiTabs-scrollButtons.Mui-disabled {
    width: 0;
  }
`;
const StyledTab = styled(Tab)`
  font-size: ${({ theme }) => theme.fonts.size.parceiro.subtitle};
  font-family: ${({ theme }) => theme.fonts.family.default};
  font-weight: 500;
  text-transform: none;
  padding: 0.75rem 0;
  margin-right: 1.5rem;
  overflow: visible;
  min-width: 0;
  color: ${({ theme }) => theme.colors.grey._300};

  &.Mui-selected {
    font-weight: 700;
    color: ${({ theme }) => theme.colors.primary._400};
  }
`;
const StyledIcon = styled(WhatsApp)`
  margin-right: 0.25rem;
  height: 24px;
  width: 24px;
`;
const LinkTelefone = styled(Link)`
  font-size: ${({ theme }) => theme.fonts.size.operacao.subtitle};
  font-family: ${({ theme }) => theme.fonts.family.default};
  font-weight: 400;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey._200};

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.primary._300};
    font-weight: 600;
    text-decoration: underline;
  }
`;
const Email = styled("span")`
  font-size: ${({ theme }) => theme.fonts.size.operacao.subtitle};
  font-family: ${({ theme }) => theme.fonts.family.default};
  font-weight: 400;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey._200};
`;

const ClienteHeader = ({
  cliente,
  tab,
  handleTabChange,
  handlePhoneClick,
  perfil,
}) => {
  return (
    <Grid item xs={12}>
      <Card>
        <Grid display={"flex"} gap={"1.5rem"}>
          <ImageContainer>
            {cliente?.nome.slice(0, 2).toUpperCase()}
          </ImageContainer>
          <Grid display={"flex"} flexDirection={"column"}>
            <NomeCliente>{cliente?.nome}</NomeCliente>
            <CpfCnpj>{formatters.strings.cpfCnpj(cliente?.cpfCnpj)}</CpfCnpj>
            <Grid container columnSpacing={2}>
              <Grid item display={"flex"} alignItems={"center"}>
                <LinkTelefone
                  onClick={() => handlePhoneClick(cliente?.telefone)}
                >
                  <StyledIcon as={WhatsApp} /> {cliente?.telefone}
                </LinkTelefone>
              </Grid>
              <Grid item display={"flex"} alignItems={"center"}>
                <Email>
                  <StyledIcon as={EmailRounded} />
                  {cliente?.email}
                </Email>
              </Grid>
            </Grid>
            <NomeParceiro>{cliente?.parceiro}</NomeParceiro>
            {perfil === "OPERACAO" && (
              <Grid container columnSpacing={2}>
                <Grid item display={"flex"} alignItems={"center"}>
                  <LinkTelefone
                    onClick={() =>
                      handlePhoneClick(cliente?.telefoneParceiro, "")
                    }
                  >
                    <StyledIcon as={WhatsApp} /> {cliente?.telefoneParceiro}
                  </LinkTelefone>
                </Grid>
                <Grid item display={"flex"} alignItems={"center"}>
                  <Email>{cliente?.nomeContatoParceiro}</Email>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        {tab && (
          <TabContainer
            value={tab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <StyledTab value={"0"} label={"Propostas"} />
            <StyledTab value={"1"} label={"Dados Pessoais"} />
            <StyledTab value={"2"} label={"Documentos"} />
          </TabContainer>
        )}
      </Card>
    </Grid>
  );
};

export default ClienteHeader;
